export const ImportUploadStatus = {
  Default: "default",
  Uploading: "uploading",
  Processing: "processing",
  Success: "success",
  Error: "error",
};
